export default __webpack_public_path__ + "static/media/img10.a7a60a2c.PNG";